var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviousChapterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.20312 13.8896H3.14746C3.9209 13.8896 4.33984 13.4707 4.33984 12.6865V1.19238C4.33984 0.375977 3.9209 0 3.14746 0H1.20312C0.418945 0 0 0.418945 0 1.19238V12.6865C0 13.4707 0.418945 13.8896 1.20312 13.8896ZM14.8027 13.6641C15.5225 13.6641 16.1025 13.1162 16.1025 12.1279V1.75098C16.1025 0.762695 15.5225 0.214844 14.8027 0.214844C14.4375 0.214844 14.1475 0.322266 13.7715 0.547852L5.24219 5.56445C4.57617 5.96191 4.29688 6.42383 4.29688 6.93945C4.29688 7.45508 4.57617 7.91699 5.24219 8.30371L13.7715 13.3311C14.1475 13.5566 14.4375 13.6641 14.8027 13.6641Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousChapterIcon);
export default __webpack_public_path__ + "static/media/previous_chapter_icon.83e52cf342154e590915662a583bff31.svg";
export { ForwardRef as ReactComponent };